import { ActionBar } from "$components/action-bar/action-bar";
import { useRegisterActionBar } from "$components/action-bar/action-bar-offset";
import { ActionBarSpacer } from "$components/action-bar/action-bar-spacer";
import type { ActionItem } from "$components/action-bar/action-item";
import { Page } from "$components/page";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  linkToBulkAmpManagement,
  linkToBulkVmpManagement,
  linkToBulkVtmManagement,
} from "../links";

const ClinicalProductPage: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const actionBarRef = useRef<HTMLElement>(null);
  useRegisterActionBar(actionBarRef);

  const actions: ActionItem[] = [
    {
      id: "clinical-product-management.ampBulk.button",
      defaultMessage: "AMP Bulk",
      onClick: () => navigate(linkToBulkAmpManagement()),
    },
    {
      id: "clinical-product-management.vmpBulk.button",
      defaultMessage: "VMP Bulk",
      onClick: () => navigate(linkToBulkVmpManagement()),
    },
    {
      id: "clinical-product-management.vtmBulk.button",
      defaultMessage: "VTM Bulk",
      onClick: () => navigate(linkToBulkVtmManagement()),
    },
  ];

  return (
    <>
      <Page data-dense>
        {children}
        <ActionBarSpacer />
      </Page>
      <ActionBar actions={actions} containerRef={actionBarRef} />
    </>
  );
};

export default ClinicalProductPage;
